import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { rolesOf, isOwner as hasOwnerRole } from './roles';

const OwnerRoute = ({ children }) => {
  const [user, setUser] = useState(undefined);
  const [loading, setLoading] = useState(true);
  const [isOwner, setIsOwner] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      setUser(user);
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, 'users', user.uid));
          setIsOwner(hasOwnerRole(rolesOf(userDoc.exists() ? userDoc.data() : null)));
        } catch (error) {
          console.error('Error checking owner access:', error);
          setIsOwner(false);
        }
      } else {
        setIsOwner(false);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) return <p>Loading...</p>;

  // Only allow owners
  return user && isOwner ? children : <Navigate to="/" />;
};

export default OwnerRoute;